/* DATA LAYER SEARCH*/

import datalayer from './dataLayer'
import debounce from 'lodash-es/debounce'

const get = (p, o) =>
  p.reduce((xs, x) => (xs && typeof xs[x] !== 'undefined') ? xs[x] : null, o)

function showSearchResultItems (searchResults) {
  const resultNames = ['ServicesResult', 'RecipeResult', 'FoodSchoolResult', 'ArticleResult', 'RecipeCategoryResult', 'ProductResult', 'StoreResult']

  return resultNames.reduce((prev, curr) => ({
    ...prev,
    [curr]: get(['result', curr, 'Stats', 'TotalHits'], searchResults)
  }), {})
}

function clickOnSearchResult (searchResults, searchInput, item, sectionName, position, positionInResultCategory) {
  let header = item.header
  if (header) {
    header = header.replace(/<\/?span[^>]*>/g, "")
  }

  datalayer.add({
    event: "autocompleteSearchClick",
    phrase: searchInput,
    suggestedPhrase: '',
    searchHits: showSearchResultItems(searchResults),
    position: position,
    resultCategory: sectionName,
    positionInResultCategory: positionInResultCategory + 1,
    recEngine: "true",
    targetURL: item.Url,
    recipeID: sectionName === 'RecipeResult' ? item.Id : null,
    recipeName: sectionName === 'RecipeResult' ? item.Title : null,
    category: sectionName
  })
}


const debounceSearchInputRes = debounce ( function (searchResults, searchInput) {
  datalayer.add({
    event: "autocompleteSearch",
    phrase: searchInput,
    suggestedPhrase: "",
    searchHits: showSearchResultItems(searchResults),
    recEngine: "true"
  })
}, 1500)


function searchInputNoRes (searchResults, searchInput) {
  datalayer.add({
    event: "autocompleteSearchZeroHits",
    phrase: searchInput,
    suggestedPhrase: "",
    searchHits: showSearchResultItems(searchResults),
    recEngine: "true"
  })
}

function showAllResultsClick (searchResults, searchInput) {
  datalayer.add({
    event: "searchShowAllResults",
    phrase: searchInput,
    suggestedPhrase: "",
    searchHits: showSearchResultItems(searchResults),
    recEngine: "true"
  })
}

function quickLinksTracking (url, name) {
  datalayer.add({
    event: "searchQuickLink",
    targetUrl: url,
    targetName: name,
    recEngine: "true"
  })
}

export default {
  clickOnSearchResult,
  debounceSearchInputRes,
  searchInputNoRes,
  showAllResultsClick,
  quickLinksTracking
}
